export default "__VITE_ASSET__0nIYJ9Jz__"